/**
 * Resolve lab, country, and area from a TRF labLocationId (locationAreaId).
 * Uses lab locations fetched from get-lab-locations API.
 */
export const resolveLabLocationById = (labLocationId, labLocationCountries) => {
  const id = labLocationId ? Number(labLocationId) : null;
  if (!id) {
    return null;
  }

  if (labLocationCountries && labLocationCountries.length) {
    for (let i = 0; i < labLocationCountries.length; i += 1) {
      const countryData = labLocationCountries[i];
      const match = countryData.location.find(loc => Number(loc.id) === id);
      if (match) {
        return {
          country: countryData.country,
          labId: match.labId,
          labLocationId: id
        };
      }
    }
  }

  return null;
};
